import React,{useState,useEffect,useRef} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AdminPanel from './AdminPanel';

const {FiStar,FiGift}=FiIcons;

const GiftCardLanding=()=> {
  const [settings,setSettings]=useState({
    title: 'Claim your $750 Sephora Gift Card now!',
    subtitle: 'Sephora Exclusive Offer',
    buttonText: 'Claim My $750 Gift Card!',
    buttonLink: 'https://gloffers.org/aff_c?offer_id=90&aff_id=163659',
    timerHours: 0,
    timerMinutes: 11,
    timerSeconds: 18,
    cardValue: '$750',
    reviewCount: '1700+',
    rating: '5.0',
    securityText: '100% Secure • Verified Offers',
    termsText: '*Terms and conditions apply. Offer available for limited time only.',
    dealsText: 'Complete three-five simple deals to earn your reward'
  });

  const [totalSeconds,setTotalSeconds]=useState(678);
  const [showAdminPanel,setShowAdminPanel]=useState(false);
  const [isAdminAuthenticated,setIsAdminAuthenticated]=useState(false);

  useEffect(()=> {
    const savedSettings=localStorage.getItem('landing_settings');
    if (savedSettings) {
      const parsedSettings=JSON.parse(savedSettings);
      setSettings(parsedSettings);
      const total=parsedSettings.timerHours * 3600 + parsedSettings.timerMinutes * 60 + parsedSettings.timerSeconds;
      setTotalSeconds(total);
    }

    const sessionId=sessionStorage.getItem('session_id');
    if (!sessionId) {
      sessionStorage.setItem('session_id',Date.now().toString());
      trackAnalytics('new_visitor');
    }

    trackAnalytics('page_view');
  },[]);

  useEffect(()=> {
    if (totalSeconds <=0) return;
    const timer=setInterval(()=> {
      setTotalSeconds(prev=> prev - 1);
    },1000);
    return ()=> clearInterval(timer);
  },[totalSeconds]);

  // Hotkey: Ctrl+Shift+Q to open admin panel
  useEffect(()=> {
    const handleKeyPress=(e)=> {
      if (e.ctrlKey && e.shiftKey && e.key==='Q') {
        e.preventDefault();
        setShowAdminPanel(true);
      }
    };
    window.addEventListener('keydown',handleKeyPress);
    return ()=> window.removeEventListener('keydown',handleKeyPress);
  },[]);

  const trackAnalytics=(action)=> {
    const analytics=JSON.parse(localStorage.getItem('landing_analytics') || '{}');
    
    switch (action) {
      case 'page_view':
        analytics.totalViews=(analytics.totalViews || 0) + 1;
        const currentHour=new Date().getHours();
        analytics.hourlyViews=analytics.hourlyViews || Array(24).fill(0);
        analytics.hourlyViews[currentHour]=(analytics.hourlyViews[currentHour] || 0) + 1;
        const device=/Mobile|Android|iPhone/.test(navigator.userAgent) 
          ? 'mobile' 
          : /Tablet|iPad/.test(navigator.userAgent) 
            ? 'tablet' 
            : 'desktop';
        analytics.deviceBreakdown=analytics.deviceBreakdown || {desktop: 0,mobile: 0,tablet: 0};
        analytics.deviceBreakdown[device]=(analytics.deviceBreakdown[device] || 0) + 1;
        break;
      case 'new_visitor':
        analytics.uniqueVisitors=(analytics.uniqueVisitors || 0) + 1;
        break;
      case 'button_click':
        analytics.buttonClicks=(analytics.buttonClicks || 0) + 1;
        break;
    }

    if (analytics.totalViews && analytics.buttonClicks) {
      analytics.conversionRate=((analytics.buttonClicks / analytics.totalViews) * 100).toFixed(1);
    }

    localStorage.setItem('landing_analytics',JSON.stringify(analytics));
  };

  const hours=String(Math.floor(totalSeconds / 3600)).padStart(2,'0');
  const minutes=String(Math.floor((totalSeconds % 3600) / 60)).padStart(2,'0');
  const seconds=String(totalSeconds % 60).padStart(2,'0');

  // Updated with young female avatars
  const reviewAvatars=[
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&q=80',
    'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=100&h=100&fit=crop&q=80',
    'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&h=100&fit=crop&q=80',
    'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=100&h=100&fit=crop&q=80',
    'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=100&h=100&fit=crop&q=80'
  ];

  const handleButtonClick=()=> {
    trackAnalytics('button_click');
    if (settings.buttonLink) {
      window.open(settings.buttonLink,'_blank');
    }
  };

  const handleAdminSave=(newSettings)=> {
    setSettings(newSettings);
  };

  if (showAdminPanel) {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b border-gray-200 p-4">
          <button
            onClick={()=> setShowAdminPanel(false)}
            className="text-gray-600 hover:text-gray-900 font-medium"
          >
            ← Back to Landing Page
          </button>
        </div>
        <AdminPanel
          onClose={()=> setShowAdminPanel(false)}
          onSave={handleAdminSave}
          initialSettings={settings}
        />
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen font-sans relative pb-24">
      <div className="container mx-auto max-w-sm p-4 text-center">
        <img 
          src="https://i.ibb.co/rRTnYQ2N/2025-holiday-core-site-buy-guide-hero-banner-irl-gift-cards-us-can-image-only-3116.jpg" 
          alt="Sephora Gift Card" 
          className="mx-auto my-4 rounded-lg shadow-lg w-full max-w-xs" 
        />
        
        <h2 className="text-xl font-semibold text-gray-800">{settings.subtitle}</h2>
        
        <div className="bg-gray-200 text-gray-800 rounded-lg p-3 my-4">
          <p className="text-xs font-bold tracking-wider">LIMITED TIME OFFER ENDS IN:</p>
          <div className="flex justify-center items-baseline space-x-2 mt-1">
            <div className="text-center">
              <p className="text-3xl font-bold">{hours}</p>
              <p className="text-xs -mt-1">Hours</p>
            </div>
            <p className="text-2xl font-bold">:</p>
            <div className="text-center">
              <p className="text-3xl font-bold">{minutes}</p>
              <p className="text-xs -mt-1">Minutes</p>
            </div>
            <p className="text-2xl font-bold">:</p>
            <div className="text-center">
              <p className="text-3xl font-bold">{seconds}</p>
              <p className="text-xs -mt-1">Seconds</p>
            </div>
          </div>
        </div>

        <p className="text-xs text-gray-600 underline cursor-pointer">
          {settings.dealsText}
        </p>

        <h1 className="text-4xl font-extrabold text-gray-900 my-4">
          {settings.title}
        </h1>

        <p className="text-xs text-gray-500 font-semibold my-2">
          {settings.securityText}
        </p>

        <img 
          src="https://i.ibb.co/TB4SS5DT/8-Sephora-jpg.webp" 
          alt="Sephora Logo" 
          className="h-8 mx-auto my-4" 
        />

        <button 
          onClick={handleButtonClick}
          className="w-full bg-black hover:bg-gray-800 text-white font-bold py-4 px-4 rounded-lg flex items-center justify-center text-lg shadow-md transition-colors"
        >
          <SafeIcon icon={FiGift} className="mr-2" />
          {settings.buttonText}
        </button>

        <div className="flex items-center justify-center my-4 space-x-4">
          <div className="flex -space-x-3">
            {reviewAvatars.map((src,index)=> (
              <img 
                key={index} 
                className="inline-block h-8 w-8 rounded-full ring-2 ring-white object-cover" 
                src={src} 
                alt={`Reviewer ${index + 1}`} 
              />
            ))}
          </div>
          <div>
            <div className="flex">
              {[...Array(5)].map((_,i)=> (
                <SafeIcon 
                  key={i} 
                  icon={FiStar} 
                  className="w-4 h-4 text-yellow-400 fill-current" 
                />
              ))}
            </div>
            <p className="text-xs text-gray-600">{settings.rating} from {settings.reviewCount} reviews</p>
          </div>
        </div>

        <p className="text-xs text-gray-500 my-4">
          {settings.termsText}
        </p>
      </div>
    </div>
  );
};

export default GiftCardLanding;